import { Loading } from '@schooly/style';
import { FC } from 'react';

import { ModalSmall } from '../../../../components/uikit-components/Modal/Modal.styled';
import { useRouter } from '../../../../context/router/useRouter';
import { useTimetableStructure } from '../../../../context/timetableStructure/WithTimetableStructure';
import { SchoolTimetableStructureCreateModalContent } from './SchoolTimetableStructureCreateModalContent';

export const SchoolTimetableStructureCreateModal: FC = () => {
  const { goBack } = useRouter();
  const {
    structure,
    id,
    isLoading,
    isSaving,
    isDeleting,
    canDelete,
    confirmChange,
    create,
    update,
    remove,
  } = useTimetableStructure();

  if (isLoading) {
    return (
      <ModalSmall open onClose={goBack}>
        <Loading />
      </ModalSmall>
    );
  }

  return (
    <SchoolTimetableStructureCreateModalContent
      structure={structure}
      isSaving={isSaving}
      isDeleting={isDeleting}
      canDelete={canDelete}
      confirmChange={confirmChange}
      onSave={id ? update : create}
      onDelete={remove}
    />
  );
};
